/**
 * Extracted from sections/ns-accordions-with-images-v2.liquid (inline <script> at line 231).
 * Config bridge: window.__nsAccordionsWithImagesV2Sections, keyed by section id. The inline block
 * only needed Liquid for the section id, so the id is handed over as data
 * and the logic now runs from a cacheable, deferred asset instead of being
 * parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances each initialise.
 */

(function () {
  var cfg = window.__nsAccordionsWithImagesV2Sections = window.__nsAccordionsWithImagesV2Sections || {};
  function boot(nsSectionId, nsSettings) {
      (function () {
        var root = document.getElementById(`shopify-section-${nsSectionId}`);
        if (!root) return;
        var items = Array.prototype.slice.call(root.querySelectorAll('[data-acc-v2-item]'));
        var media = Array.prototype.slice.call(root.querySelectorAll('[data-acc-v2-media]'));
        if (!items.length) return;

        function activate(blockId) {
          items.forEach(function (item) {
            var on = item.getAttribute('data-block-id') === blockId;
            item.classList.toggle('is-active', on);
            var toggle = item.querySelector('[data-acc-v2-toggle]');
            if (toggle) toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
          });
          media.forEach(function (m) {
            var on = m.getAttribute('data-media-for') === blockId;
            m.classList.toggle('is-active', on);
            if (!on) {
              // A hidden YouTube/Vimeo iframe keeps playing audio; resetting the
              // src stops it without loading anything new (lazy iframes only
              // fetch when visible again).
              var frame = m.querySelector('[data-acc-v2-video]');
              if (frame && frame.src) frame.src = frame.src;
            }
          });
        }

        items.forEach(function (item) {
          var toggle = item.querySelector('[data-acc-v2-toggle]');
          if (toggle) {
            toggle.addEventListener('click', function () {
              activate(item.getAttribute('data-block-id'));
            });
          }
        });

        if (window.Shopify && window.Shopify.designMode) {
          root.addEventListener('shopify:block:select', function (event) {
            var item = event.target.closest('[data-acc-v2-item]');
            if (item) activate(item.getAttribute('data-block-id'));
          });
        }
      })();
  
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
